<template>
  <div class="pdfBox">
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading type="spinner" color="#1989fa" vertical>
          加载中...
        </van-loading>
      </div>
    </van-overlay>
    <div id="previewPdf"></div>
  </div>
</template>
<script>
import pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css'
import listJson from './message.json'
import { getPdf } from '@/api/index'
export default {
  data() {
    return {
      pdfh5: null,
      url: "",
      show: false
    }
  },
  mounted() {
    // 回获取路由参数
    const { id } = this.$route.query;
    let data = listJson.find(item => item.id === id);
    this.openFile(data.pdfUrl)
  },
  methods: {
    openPdf() {     //url：PDF文件地址
      this.pdfh5 = new pdfh5('#previewPdf', {
        // pdfurl: this.url,
        data: this.url,
      });
      this.pdfh5.on('success', () => {
      });
    },
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 1 } })
    },
    openFile(val) {
      this.show = true
      getPdf({ fileName: val }).then(res => {
        this.url = res
        this.show = false
        this.openPdf()
      }).catch(err => {
        this.show = false
        this.$toast.fail('加载失败')
      })
    },
  }
}
</script>
<style lang="less" scoped>
.pdfBox {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  overflow: hidden;
  z-index: 99;
  width: 100%;
  color: red;

  #previewPdf {
    height: 100vh;
  }
}

.pdfBox #previewPdf .textLayer .textLayerItem {
  font-size: 50px;
}

.pdfjs .backTop {
  background-color: none !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>